import React, { useEffect, useState } from 'react'

import { Backdrop, Checkbox, FormControlLabel, Modal } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import CircularProgress from '@material-ui/core/CircularProgress'
import DoneAllIcon from '@material-ui/icons/DoneAll'
import { makeStyles } from '@material-ui/core/styles'

import PromptModal from 'components/GoalWizard/PromptModal'
import ExitIcon from '../../../assets/Icons/ExitIcon'
import palette from 'theme/palette'

/** @param {any} props */
export const GoalWizardNavbar = ({
  title,
  context,
  canSave,
  isSaved,
  loading,
  saveDisabled = false,
  exitLabel = 'Sair para o painel',
  savedMessage = 'Informações salvas com sucesso',
  logoSrc = '/images/logo-blue.svg',
  rememberExitPromptKey = null,
  exitPrompt = null,
  onLogoClick = () => {},
  onSave = undefined,
  onExit,
  onExitWithSave = undefined
}) => {
  const styles = useStyles()
  const [notShowAgain, setNotShowAgain] = useState(false)
  const [isShowModal, setIsShowModal] = useState(false)

  useEffect(() => {
    if (rememberExitPromptKey && localStorage.getItem(rememberExitPromptKey)) {
      setNotShowAgain(true)
    }
  }, [rememberExitPromptKey])

  const handleToggleShowModal = show => {
    setNotShowAgain(show)
    if (rememberExitPromptKey && show) {
      localStorage.setItem(rememberExitPromptKey, String(show))
    }
    if (rememberExitPromptKey && !show) {
      localStorage.removeItem(rememberExitPromptKey)
    }
  }

  const handleExitClick = () => {
    if (exitPrompt?.enabled && !notShowAgain) {
      setIsShowModal(true)
      return
    }

    onExitWithSave ? onExitWithSave() : onExit()
  }

  return (
    <div className={styles.container}>
      <div onClick={onLogoClick} className={styles.logoContainer}>
        <img src={logoSrc} alt='NeoPro Logo' />
        <span className={styles.title}>
          {title} {context && <strong>{context}</strong>}
        </span>
      </div>

      <div className={styles.buttonContainer}>
        {isSaved && (
          <div className={styles.saveMessageContainer}>
            <DoneAllIcon />
            <Typography className={styles.saveMessage}>{savedMessage}</Typography>
          </div>
        )}
        {canSave && (
          <Button className={styles.button} onClick={onSave} disabled={loading || saveDisabled}>
            {loading ? (
              <CircularProgress style={{ color: '#27AE60' }} size={20} />
            ) : (
              'Salvar'
            )}
          </Button>
        )}
        <Button
          variant='outlined'
          onClick={handleExitClick}
          className={styles.button}
          color='primary'
        >
          {exitLabel}
        </Button>

        {exitPrompt?.enabled && (
          <Modal
            open={isShowModal}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{ timeout: 500 }}
          >
            <PromptModal
              icon={<ExitIcon />}
              onClose={() => setIsShowModal(false)}
              title={exitPrompt.title}
              description={exitPrompt.description}
              leftTitle={exitPrompt.cancelLabel}
              onLeft={() => setIsShowModal(false)}
              rightTitle={exitPrompt.confirmLabel}
              onRight={onExit}
            >
              {rememberExitPromptKey && (
                <FormControlLabel
                  checked={notShowAgain}
                  onChange={() => handleToggleShowModal(!notShowAgain)}
                  control={<Checkbox color='primary' name='checkedA' />}
                  label='Não mostrar novamente'
                />
              )}
            </PromptModal>
          </Modal>
        )}
      </div>
    </div>
  )
}

export default GoalWizardNavbar

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
    padding: '20px 20px',
    background: '#fff'
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
  },
  title: {
    fontFamily: 'Roboto, sans-serif',
    marginLeft: 10,
    fontSize: 14
  },
  button: {
    color: palette.primary.main,
    textTransform: 'none',
    marginRight: theme.spacing(1),
    fontWeight: 'medium'
  },
  buttonContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  saveMessageContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  saveMessage: {
    color: '#27AE60',
    marginLeft: '0.5rem',
    marginRight: 10
  }
}))
